// Sentry initialization for the browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs'
import { sentryDsn } from '@fe/common/constants/env'

// Events are sent through the app's own API route (`tunnel`) instead of directly
// to Sentry, so browser ad / tracking blockers (which block requests to
// `*.sentry.io` by host) don't drop them. Gated on the DSN so dev / e2e /
// unconfigured builds don't initialise Sentry (and don't tunnel to nowhere).
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    tunnel: '/api/sentryReport',
    maxBreadcrumbs: 50,
    tracesSampleRate: 0,
  })
}
